export default __webpack_public_path__ + "static/media/TablaDeTalles.0bfa5bba.jpg";